// import React from 'react'
// import { LoginSucessfull } from "../../context/AuthenticationSlice";
// import { useSelector } from "react-redux";
// import { Navigate, Outlet } from 'react-router-dom';
// export const ProtectedRoute = () => {
//  const { CredenceAccountNumber } = useSelector(
//         (state) => state.Authentication
//       );
//       // console.log(CredenceAccountNumber)
//   return CredenceAccountNumber ? <Outlet/> : <Navigate to="/Login"/>
// }
import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import { Navigate, Outlet } from 'react-router-dom';

export const ProtectedRoute = () => {
  const { CredenceAccountNumber } = useSelector((state) => state.Authentication);
  const rehydrated = useSelector((state) => state._persist?.rehydrated);

  // useEffect(() => {
  //   console.log('Rehydrated:', rehydrated);
  //   console.log('CredenceAccountNumber:', CredenceAccountNumber);
  // }, [rehydrated, CredenceAccountNumber]);

  // if (!rehydrated) {
  //   return <div>Loading...</div>;
  // }

  return CredenceAccountNumber ? <Outlet /> : <Navigate to="/Pay" />;
};
